import React from "react";
import Flex from "../../Flex";
import { getProgressPercentage, normalizeProgressValue } from "../helpers";
import ProgressBarLabel from "./ProgressBarLabel";
import * as S from "./styled";
import { ProgressBarProps } from "./types";

const ProgressBar = ({
    value,
    minValue = 0,
    maxValue = 100,
    label = "none",
    text = `${normalizeProgressValue(value, minValue, maxValue).toFixed()}%`,
    width = "320px",
    progressColor = "primary-800",
    progressBackgroundColor = "primary-50",
    labelColor = "primary-1200",
    labelSize = "label-small-medium"
}: ProgressBarProps) => {
    const getFlexDirection = () => {
        if (label === "top") return "column-reverse";
        if (label === "bottom") return "column";
        return "row";
    };

    const getItemDirection = () => {
        if (label === "top") return "flex-start";
        if (label === "bottom") return "flex-end";
        return "center";
    };

    const getSpacing = () => {
        if (label === "top") return 0.5;
        if (label === "bottom") return 1;
        return 1.5;
    };

    return (
        <Flex flexDirection={getFlexDirection()} spacing={getSpacing()} alignItems={getItemDirection()} width={width}>
            <ProgressBarLabel
                text={typeof text === "string" ? text : text(value, minValue, maxValue)}
                label={label}
                labelColor={labelColor}
                labelSize={labelSize}
            >
                <S.ProgressBarBackground $progressBackgroundColor={progressBackgroundColor}>
                    <S.ProgressBarProgress
                        $progress={getProgressPercentage(value, minValue, maxValue)}
                        $progressColor={progressColor}
                    />
                </S.ProgressBarBackground>
            </ProgressBarLabel>
        </Flex>
    );
};

export default ProgressBar;
